import {
  formatReviewDate,
  getReviewCycleDisplayName,
  getOpenReviewCycles,
  shouldShowReviewCycle,
} from './nimReviewCycles'

const AM_PARTICIPATION_NOTES = {
  'School day': 'School-branded Academic Marathon with authorization',
  'school day': 'School-branded Academic Marathon with authorization',
  'Standard registration': 'Student Independent Registration Coordinated by School',
  'standard arrangement': 'Student Independent Registration Coordinated by School',
  'Standard arrangement': 'Student Independent Registration Coordinated by School',
}

export function getRegistrationRowBu(row) {
  const raw = row && row.project && row.project.project_BU
  return raw ? String(raw).trim().toUpperCase() : ''
}

export function getAmParticipationNote(row) {
  const value = (row && row.participation_arrangement) || 'Standard registration'
  return AM_PARTICIPATION_NOTES[value] || value
}

function normalizeEntryDates(projectManage) {
  if (!projectManage) return []
  let entries = projectManage.entry_date || projectManage.entry_dates || []
  if (typeof entries === 'string') {
    try {
      entries = JSON.parse(entries)
    } catch (e) {
      return []
    }
  }
  return Array.isArray(entries) ? entries : []
}

/** Prefer open review cycles for Notes column (max 2: current + next). */
export function getNimReviewCyclesForNotes(row) {
  const entries = normalizeEntryDates(row && row.projectManage)
  const open = getOpenReviewCycles(entries)
  if (open.length) return open.slice(0, 2)
  return entries.filter((cycle) => shouldShowReviewCycle(cycle)).slice(0, 2)
}

export {
  formatReviewDate,
  getReviewCycleDisplayName,
}
